const AuthUtils = {
    minPasswordLength: 6,
}

export default AuthUtils;
